// src/components/layout/Footer.js
import React from 'react';
import { Box, Container, Typography, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function Footer() {
  const accent = '#c9b37e';

  return (
    <Box
      component="footer"
      sx={{
        position: 'sticky',
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: '#000',
        color: '#fff',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        py: 2,
        zIndex: 10,
      }}
    >
      <Container
        disableGutters
        maxWidth={false}
        sx={{
          px: { xs: 3, md: 8 },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: '#FFFFFF',
            fontSize: '0.75rem',
            letterSpacing: '0.5px',
          }}
        >
          © {new Date().getFullYear()} Marrakech Reserve. All rights reserved.
        </Typography>

        <Box sx={{ display: 'flex', gap: { xs: 2, md: 4 } }}>
          <MuiLink
            component={RouterLink}
            to="/privacy-policy"
            underline="hover"
            sx={{
              color: '#fff',
              fontSize: '0.75rem',
              letterSpacing: '0.5px',
              '&:hover': { color: accent },
            }}
          >
            Privacy Policy
          </MuiLink>

          <MuiLink
            component={RouterLink}
            to="/terms-conditions"
            underline="hover"
            sx={{
              color: '#fff',
              fontSize: '0.75rem',
              letterSpacing: '0.5px',
              '&:hover': { color: accent },
            }}
          >
            Terms of Service
          </MuiLink>

          <MuiLink
            component={RouterLink}
            to="/contact-us"
            underline="hover"
            sx={{
              color: '#fff',
              fontSize: '0.75rem',
              letterSpacing: '0.5px',
              '&:hover': { color: accent },
            }}
          >
            Contact
          </MuiLink>
        </Box>
      </Container>
    </Box>
  );
}
